<div class="nearby-page">
  <!-- Top bar -->
  <div class="top-bar">
    <button class="btn-back" (click)="goBack()">
      <span class="back-arrow">&#8592;</span>
    </button>
    <h1 class="top-title">Cerca de ti</h1>
    <button class="btn-locate" (click)="centerOnUser()" [disabled]="!mapReady">
      <span>&#9737;</span>
    </button>
  </div>

  <!-- View toggle -->
  <div class="view-toggle">
    <button [class.active]="activeView === 'map'" (click)="setView('map')">Mapa</button>
    <button [class.active]="activeView === 'list'" (click)="setView('list')">Lista</button>
    <span class="results-badge" *ngIf="restaurants.length > 0">{{ restaurants.length }}</span>
  </div>

  <!-- Map view -->
  <div class="map-wrapper" [class.hidden]="activeView !== 'map'">
    <div #mapContainer class="map-container"></div>

    <!-- Loading overlay -->
    <div class="map-overlay" *ngIf="loading">
      <div class="loader-ring"></div>
      <span>Buscando lugares...</span>
    </div>

    <!-- Location error overlay -->
    <div class="map-overlay" *ngIf="locationError && !loading">
      <span class="overlay-icon">&#128225;</span>
      <span>No se pudo obtener tu ubicacion</span>
      <button class="btn-retry" (click)="getCurrentLocation()">Reintentar</button>
    </div>
  </div>

  <!-- List view -->
  <div class="list-wrapper" *ngIf="activeView === 'list'">
    <div *ngIf="loading" class="list-loading">
      <div class="loader-ring"></div>
      <span>Buscando lugares cercanos...</span>
    </div>

    <div *ngIf="!loading && restaurants.length === 0" class="empty-state">
      <span class="empty-icon">&#128269;</span>
      <p>No se encontraron lugares cercanos</p>
      <button class="btn-retry" (click)="getCurrentLocation()">Buscar de nuevo</button>
    </div>

    <div class="restaurant-list" *ngIf="!loading && restaurants.length > 0">
      <div
        *ngFor="let place of restaurants"
        class="restaurant-card"
        [class.selected]="selectedPlace?.id === place.id"
        (click)="onRestaurantClick(place)"
      >
        <div class="card-left">
          <span class="card-emoji">{{ getCategoryIcon(place.category) }}</span>
        </div>
        <div class="card-info">
          <h3 class="card-name">{{ place.name }}</h3>
          <span class="card-category">{{ place.category || 'Restaurante' }}</span>
          <span class="card-address">{{ place.address }}</span>
          <span class="card-distance" *ngIf="place.distance">{{ formatDistance(place.distance) }}</span>
        </div>
        <div class="card-actions">
          <button class="btn-icon" (click)="openDirections(place); $event.stopPropagation()" title="Direcciones">
            &#128506;
          </button>
          <button class="btn-icon" (click)="goToBusinessDetail(place); $event.stopPropagation()" title="Ver local">
            &#8250;
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Selected place detail (bottom sheet) -->
  <div class="place-detail" *ngIf="selectedPlace && activeView === 'map'" (click)="$event.stopPropagation()">
    <div class="detail-header">
      <div class="detail-title-row">
        <span class="detail-emoji">{{ getCategoryIcon(selectedPlace.category) }}</span>
        <div>
          <h3 class="detail-name">{{ selectedPlace.name }}</h3>
          <span class="detail-category">{{ selectedPlace.category || 'Restaurante' }}</span>
        </div>
      </div>
      <button class="btn-close-detail" (click)="selectedPlace = null">&times;</button>
    </div>
    <p class="detail-address">{{ selectedPlace.address }}</p>
    <span class="detail-distance" *ngIf="selectedPlace.distance">{{ formatDistance(selectedPlace.distance) }}</span>
    <div class="detail-actions">
      <button class="btn-detail" (click)="openDirections(selectedPlace)">Ir</button>
      <button class="btn-detail primary" (click)="goToBusinessDetail(selectedPlace)">Ver local</button>
    </div>
  </div>
</div>
